import React from "react";

const RefundPolicy = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Refund & Return Policy</h1>

        <p>
          At <strong>Freshcart</strong>, we aim to provide the best quality
          grocery products. Please read our refund and return policy carefully
          before placing an order.
        </p>

        <Section title="1. Non-Returnable Items (Important)">
          <p>
            Due to the perishable nature of certain products, the following
            items are <strong>non-returnable and non-refundable</strong>:
          </p>
          <ul>
            <li>Fresh Vegetables</li>
            <li>Fruits</li>
            <li>Dairy Products</li>
            <li>Frozen Items</li>
            <li>Any perishable grocery items</li>
          </ul>
          <p>
            These items cannot be returned once delivered under any
            circumstances.
          </p>
        </Section>

        <Section title="2. Eligible for Return / Refund">
          <ul>
            <li>Wrong item delivered</li>
            <li>Damaged product received</li>
            <li>Expired product delivered</li>
          </ul>
          <p>
            You must report the issue within <strong>24 hours</strong> of
            delivery with proper proof (photo/video).
          </p>
        </Section>

        <Section title="3. Refund Process">
          <p>
            After verification, refunds will be processed within 3–5 business
            days via the original payment method (UPI / Bank). For Cash on
            Delivery orders, refund will be sent to your provided UPI or bank
            details.
          </p>
        </Section>

        <Section title="4. Order Cancellation">
          <p>
            Orders can be cancelled only before they are packed or dispatched.
            Once shipped, cancellation is not allowed.
          </p>
        </Section>

        <Section title="5. Contact for Support">
          <p>
            If you face any issue, contact us:
            <br />
            <strong>Freshcart</strong>
            <br />
            Nijhra, Sonaili, Katihar, Bihar
            <br />
            Phone: 7856000970
            <br />
            Email: support@freshcart4u.com
          </p>
        </Section>

        <p style={styles.updated}>Last Updated: January 2026</p>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginTop: "22px" }}>
    <h2 style={{ color: "#2c3e50" }}>{title}</h2>
    <div>{children}</div>
  </div>
);

const styles = {
  page: {
    background: "#f4f6f8",
    minHeight: "100vh",
    padding: "40px 20px",
    fontFamily: "Arial, Helvetica, sans-serif",
  },
  container: {
    maxWidth: "900px",
    margin: "auto",
    background: "#fff",
    padding: "30px",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    lineHeight: "1.7",
    color: "#333",
  },
  title: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#2c3e50",
  },
  updated: {
    marginTop: "30px",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
  },
};

export default RefundPolicy;